export const Resposne = {
    0:{desc:"NORMAL",message:"NORMAL"},
    20001:{desc:"INVALID_ARGUMENT",message:"Gas fee is higher than the input amount."}
}